import React from "react";

import { css } from "@emotion/react";

import { ReactTFC } from "../../utils/fp/missing-ts-parts";
import { SwarovskiButton } from "../_shared-components/ui-elements/SwarovskiButton";
import { CSS_COLORS } from "../../styles/styles-css-variables";
import { CSS_MQ } from "../../styles/breakpoints";
import { ContentfulComponentCMSHook } from "@swo/shared";
import { CtaBannerComponentType } from "@swo/storefront";
import { getComponentCMSClassname } from "../cms/edit-overlay/component-hook-class";
import { EXPERIMENTAL_TextWithProductNameRenderer } from "../../domain/swarovski-optik/products/product-name/product-name-renderer";
import { ContentfulImage2 } from "../_shared-components/image-related/ContentfulImage2";
import { fontColor, FONTS, fontSize } from "../../styles/fonts";

const wrapperStyles = css`
  display: grid;
  grid-gap: 40px;

  ${CSS_MQ.atMostXs} {
    grid-gap: 20px;
    grid-template-rows: 1fr auto;
  }

  max-width: var(--max-content-width-new);
  margin-left: auto;
  margin-right: auto;

  grid-template-columns: none;
  grid-template-rows: 3fr 2fr;

  ${CSS_MQ.atMostXs} {
    height: 460px;
    width: 100%;
  }

  ${CSS_MQ.atLeastSm} {
    grid-template-columns: repeat(2, minmax(0, 1fr));
    grid-template-rows: none;
    height: 360px;
  }

  ${CSS_MQ.atLeastMd} {
    height: 400px;
  }

  ${CSS_MQ.atLeastLg} {
    height: 500px;
  }

  background-color: ${CSS_COLORS.GreenWhite};
`;

export const CTABannerComponent: ReactTFC<CtaBannerComponentType & ContentfulComponentCMSHook> = props => {
  return (
    <div className={getComponentCMSClassname(props?.sys?.id)} css={wrapperStyles}>
      <div
        css={css`
          position: relative;
          width: 100%;
          height: 100%;
        `}
      >
        <ContentfulImage2
          assetId={props.backgroundImage.sys.id}
          contentfulUrl={props.backgroundImage.url}
          sizes="(max-width: 576px) 100vw, (max-width: 1480px) 50vw, 740px"
          css={css`
            height: 100%;
            width: 100%;

            position: absolute;

            object-fit: cover;
            object-position: center;
          `}
          withTransparency={true}
          cropping={undefined}
          alt={props.backgroundImage.description || props.backgroundImage.title}
        />
      </div>
      <div
        css={css`
          ${CSS_MQ.atMostXs} {
            width: calc(100% - 2 * 18px);
            justify-self: center;
            align-self: flex-end;

            padding-bottom: 20px;
          }

          ${CSS_MQ.atLeastSm} {
            align-self: center;

            width: 45em;
            max-width: 90%;
          }
        `}
      >
        <span className={"u-uppercase"} css={[FONTS.MinervaModern500, fontColor.green, fontSize.x5x]}>
          <EXPERIMENTAL_TextWithProductNameRenderer text={props.headline} />
        </span>

        {props.callToAction && (
          <span
            css={css`
              margin-top: 24px;
              display: block;
            `}
          >
            <SwarovskiButton
              variant={"outline"}
              as={"a"}
              isInternal={props.callToAction.type === "Internal Link"}
              link={props.callToAction.data}
              target={props.callToAction.openInNewTab ? "_blank" : undefined}
            >
              {props.callToAction.label}
            </SwarovskiButton>
          </span>
        )}
      </div>
    </div>
  );
};
